import { Configuration, RedirectRequest, LogLevel } from "@azure/msal-browser";
import Config from '@/configurations'
import { appInsights } from "@/hooks/appInsights";

// Config object to be passed to Msal on creation
export const msalConfig: Configuration = {
    auth: {
        clientId: Config.FEClientId,
        authority: Config.Authority,
        redirectUri: Config.RedirectUri,
        postLogoutRedirectUri: Config.RedirectUri,
        navigateToLoginRequestUrl: true,
    },    
    cache: {
        cacheLocation: 'sessionStorage', 
        storeAuthStateInCookie: false,
    },
    system: {
        allowPlatformBroker: false, // Disables WAM Broker
        loggerOptions: {
            loggerCallback: (level: any, message: any, containsPii: any) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        appInsights.trackException({ exception: new Error(message) });
                        console.error(message);
                        return;
                    default:
                        return;
                }
            },
        }
    },
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest: RedirectRequest = {
    scopes: [ Config.APIAuthScope ],
    redirectUri: Config.RedirectUri,
    redirectStartPage: Config.RedirectUri,
};

// Add here the endpoints for MS Graph API services you would like to use.
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};

// Requires the User.ReadBasic.All (or User.Read.All) delegated permission to be
// granted + admin-consented on the app registration - User.Read only covers "me".
export const graphPhotoRequest = {
    scopes: ["User.ReadBasic.All"],
};

// "me" endpoints only need the default User.Read scope, already consented at sign-in.
export const graphMeRequest = {
    scopes: ["User.Read"],
};